// An explicit `behavior: 'smooth'` in JS ignores the CSS reduced-motion rule, so scroll calls ask here
export const getScrollBehavior = (): ScrollBehavior =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
